<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <v-card
    v-if="
      Object.keys(getField('metadata')).includes(
        'data_processes_and_conditions',
      ) ||
      (getField('licences') && getField('licences').length) ||
      (getField('metadata')['data_access_condition'] &&
        Object.keys(getField('metadata')['data_access_condition']).length) ||
      (getField('metadata')['data_curation'] &&
        Object.keys(getField('metadata')['data_curation']).length) ||
      (getField('metadata')['data_deposition_condition'] &&
        Object.keys(getField('metadata')['data_deposition_condition'])
          .length) ||
      (getField('metadata')['data_preservation_policy'] &&
        Object.keys(getField('metadata')['data_preservation_policy']).length) ||
      (getField('metadata')['certifications_and_community_badges'] &&
        getField('metadata')['certifications_and_community_badges'].length)
    "
    class="pa-4 d-flex flex-column overflow-initial"
    border
    :color="backColor"
    tile
    elevation="3"
  >
    <!-- Data Conditions -->
    <SectionTitle title="Data Processes And Conditions" />
    <!--  container  -->
    <div class="d-flex flex-column ml-2 min-height-40">
      <div
        v-if="
          (getField('metadata')['data_processes_and_conditions'] &&
            getField('metadata')['data_processes_and_conditions'].length) ||
          (getField('licences').length && getField('licences')) ||
          (getField('metadata')['certifications_and_community_badges'] &&
            getField('metadata')['certifications_and_community_badges'].length >
              0)
        "
      >
        <!-- DataProcessAndCondition component -->
        <DataProcessAndCondition />
        <!-- Licences component -->
        <v-card
          v-for="(item, key, index) in generateDataConditions()"
          :key="key + '_' + index"
          class="pa-4 mt-15 d-flex flex-column overflow-initial"
          border
          color="white"
          tile
          elevation="3"
        >
          <Icon :item="item.icon" size="20" class="pt-2" />
          <v-card-title class="pa-0 text--primary card-title-customize">
            {{ $filters.capitalize(cleanString(key)) }}
          </v-card-title>
          <v-card-text class="ma-0 pt-8">
            <div v-if="key === 'licences'">
              <p v-if="currentRecord.fairsharingRecord.exhaustiveLicences">
                This is a complete list of licences applicable to the resource.
              </p>
              <p v-else>
                This is a subset of licences recommended by the resource or most
                commonly used by its users.
              </p>
            </div>
            <v-card
              v-for="(subItem, subIndex) in item.data"
              :key="subItem.name + '_' + subIndex"
              class="pa-4 mt-2 d-flex flex-column v-card-hover"
              flat
              border
            >
              <div v-if="subItem.url">
                <a :href="subItem.url" target="_blank" class="underline-effect">
                  {{ subItem.name }}
                </a>
                <span v-if="subItem.spdxLink">
                  <a :href="subItem.spdxLink" target="_blank">
                    <img
                      src="/assets/icons/logo_spdx_60.png"
                      alt="Icon for SPDX (System Package Data Exchange)"
                      style="padding-bottom: 7px; padding-left: 3px"
                    />
                  </a>
                </span>
              </div>
              <div v-else class="d-flex flex-column">
                <span>{{ subItem.name }}</span>
                <span
                  v-if="
                    subItem.id &&
                    subItem.id !== 'undefined' &&
                    getLicenceRelation(subItem.id) !== 'undefined'
                  "
                >
                  relationship:
                  <strong
                    >({{ cleanString(getLicenceRelation(subItem.id)) }})</strong
                  >
                </span>
                <span v-if="subItem.spdxLink">
                  <a :href="subItem.spdxLink" target="_blank">
                    <img
                      src="/assets/icons/logo_spdx_60.png"
                      alt="Icon for SPDX (System Package Data Exchange)"
                      style="padding-bottom: 7px; padding-left: 3px"
                    />
                  </a>
                </span>
              </div>
            </v-card>
          </v-card-text>
        </v-card>
      </div>
      <!-- Other data items component -->
      <div
        v-if="
          (getField('metadata')['data_access_condition'] &&
            Object.keys(getField('metadata')['data_access_condition'])
              .length) ||
          (getField('metadata')['data_curation'] &&
            Object.keys(getField('metadata')['data_curation']).length) ||
          (getField('metadata')['data_deposition_condition'] &&
            Object.keys(getField('metadata')['data_deposition_condition'])
              .length) ||
          (getField('metadata')['data_preservation_policy'] &&
            Object.keys(getField('metadata')['data_preservation_policy'])
              .length)
        "
      >
        <OtherDataProcesses />
      </div>
    </div>
    <section />
  </v-card>
</template>

<script>
import { mapGetters, mapState } from "vuex";

import Icon from "@/components/Icon";
import DataProcessAndCondition from "@/components/Records/Record/DataProcessesAndConditions/DataProcessAndCondition";
import OtherDataProcesses from "@/components/Records/Record/DataProcessesAndConditions/OtherDataProcesses";
import SectionTitle from "@/components/Records/Record/SectionTitle";
import clearString from "@/utils/stringUtils";

export default {
  name: "DataProcessesAndConditions",
  components: {
    SectionTitle,
    Icon,
    OtherDataProcesses,
    DataProcessAndCondition,
  },
  mixins: [clearString],
  props: {
    backColor: {
      default: null,
      type: String,
    },
  },
  computed: {
    ...mapGetters("record", ["getField"]),
    ...mapState("record", ["currentRecord"]),
  },
  methods: {
    generateDataConditions: function () {
      let processedData = {};
      const community_badges =
        this.getField("metadata")["certifications_and_community_badges"];
      const licences = this.getField("licences");

      // // adding community badges if available
      if (community_badges && community_badges.length > 0) {
        processedData["certifications_and_community_badges"] = {
          data: [],
          icon: "certificate",
        };
        community_badges.forEach((community_badge) => {
          processedData["certifications_and_community_badges"].data.push(
            community_badge,
          );
        });
      }

      //adding licenses if available
      if (licences.length) {
        processedData["licences"] = {
          data: [],
          icon: "licences",
        };
        licences.forEach((licence) => {
          processedData["licences"].data.push(licence);
        });
      }
      return processedData;
    },
    getLicenceRelation(licenceId) {
      return this.getField("licenceLinks").find(
        (obj) => obj.licence.id === licenceId,
      ).relation;
    },
  },
};
</script>
